<script>
    import { map } from '@/views/brandside/area3.js'
    export default {
        name: 'Common',
        Url: 'http://58.216.246.60:1887/',
        SuccessMsg: '操作成功',
        methods: {
            getUrl() {
                return 'http://58.216.246.60:1887/';
            },
            // 解析排序数组
            handleSortList(arr, name, value) {
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i].SortName === name) {
                        arr.splice(i, 1);
                    }
                }
                if (value !== null) {
                    arr.push({SortName: name, Asc: value === 'ascending' ? true : false});
                }
                return arr;
            },
            getDatetime() {
                let mymonth = new Date().getMonth() + 1
                let myday = new Date().getDate()
                if (mymonth < 10) {
                    mymonth = "0" + mymonth;
                }
                if (myday < 10) {
                    myday = "0" + myday;
                }
                let datetime = (new Date().getFullYear() + '-' + mymonth + '-' + myday + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds()).toString()
                return datetime
            },
            // 数组转换为字符串
            arrToStr(arr) {
                if (arr.length > 0) {
                    let str = ''
                    for (let i = 0; i < arr.length; i++) {
                        str = str + arr[i] + ','
                    }
                    return str.substr(0, str.length - 1)
                } else {
                    return ''
                }
            },
            //
            getArea(str){
                let arr = map
                if(str != null){
                    let arrarea = str.toString().split('/')
                    if(arrarea.length == 1){
                        return arr[arrarea[0]]
                    } else if (arrarea.length == 2){
                        return arr[arrarea[0]] + '/' + arr[arrarea[1]];
                    } else if (arrarea.length == 3) {
                        return arr[arrarea[0]] + '/' + arr[arrarea[1]] + '/' + arr[arrarea[2]];
                    } else {
                        return str
                    }
                } else {
                    return str
                }
            },
        }
    };
</script>
